import BaseEvent, {
  BaseGetEvent,
  IBaseEvent,
} from 'hooks/context/EventCollector/events/BaseEvent';

export interface ILinkEvent extends IBaseEvent {
  type: 'link';
  toJSON(): BaseGetEvent & {
    type: ILinkEvent['type'];
    content: string;
  };
}

export default class LinkEvent extends BaseEvent implements ILinkEvent {
  type = 'link' as const;

  private content: string;

  constructor({
    description,
    content,
  }: {
    description: string;
    content: string;
  }) {
    super(description);
    this.content = content;
  }

  override toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      content: this.content,
    };
  }
}
